module.exports = __webpack_public_path__ + "static/media/02.5c7018ba.JPG";